import { EuiListGroupItem } from '@elastic/eui';
import {PropTypes} from "prop-types";
import React, { useEffect, useState } from 'react';
import { Listado } from '../../../../../shared/components/Listas';

export const ListadoFuncionesSubFunciones = (props) =>{

  let {options,onRemove}=props;
  let [listOptions,setListOptions] = useState([]);

  useEffect(()=>{
    setListOptions(getOptions(options))
  },[options])


  const getOptions = (options) =>{
    return options && options.map((o)=>{
      return (<EuiListGroupItem
      id={o.idFuncion+o.idSubFuncion}
      iconType="list"
      label={`${o.funcion} / ${o.subFuncion}`}
      isActive
      extraAction={{
        color: 'danger',
        onClick: ()=>onRemove & onRemove(o.idFuncion,o.idSubFuncion),
        iconType: 'crossInACircleFilled',
        iconSize: 's',
        alwaysShow: true,
      }}
    />)
    })
  }

  return (
    <Listado {...props} listOptions={listOptions} name="listadoFuncionesSubFunciones"/>
  )
}

export default ListadoFuncionesSubFunciones